export type Range<T> = [T, T]
export type PickerDate = Date | null
export type PickerValue = PickerDate | Range<PickerDate>

export enum DatePickerOptionValues {
  All_time = 'all-time',
  Last_24_hours = 'last-24-hours',
  Last_7_days = 'last-7-days',
  Last_30_days = 'last-30-days',
  Last_12_months = 'last-12-months',
  Custom_range = 'custom-range',
}
